<template>
    <div class="content-container">
        <div class="content-wrapper">
            <h1>Добавить бота</h1>
            <div class="content">
                <div class="connect-bot">
                    <div class="list-connect">
                        <a class="list-connect-item" href="/add-bot">
                            <span class="list-connect-item-icon"
                                ><img
                                    src="../assets/img/telegram_icon.svg"
                                    alt="Telegram"
                            /></span>
                            <span>Telegram</span>
                        </a>
                    </div>
                    <div class="connect-bot-well">
                        <div class="connect-bot-containers">
                            <div class="connect-bot-top-container">
                                <div class="connect-bot-info">
                                    <h2>Telegram бот</h2>
                                    <p>
                                        Чтобы автоматизировать бота, необходимо
                                        ввести ключ(токен) вашего бота.
                                    </p>
                                    <p class="small">
                                        Ключ(токен) бота можно получить в
                                        Telegram у бота https://t.me/BotFather
                                    </p>
                                </div>
                                <div class="connect-bot-icon">
                                    <img
                                        src="../assets/img/icon_connect_telegram.svg"
                                    />
                                </div>
                            </div>
                        </div>
                        <form
                            method="post"
                            class="form-bot-add"
                            id="form-bot-add"
                        >
                            <p>
                                <label
                                    ><b
                                        >Введите ключ доступа (токен бота)</b
                                    ></label
                                >
                            </p>
                            <div class="form-bot-add-control">
                                <input
                                    type="text"
                                    name="token"
                                    class="form-bot-add-control-input"
                                    placeholder="5620123107:AAGiiNvY5RImSa5vXFt5rHlpiFNoxDbdWnY"
                                    v-model="token"
                                    required
                                />
                                <button
                                    form="form-bot-add"
                                    type="button"
                                    class="form-bot-add-control-btn"
                                    @click="sendToken()"
                                >
                                    Подключить
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { API_URL } from "@/config";
export default {
    name: 'AddBot',
    data() {
        return {
            token: '',
        }
    },
    components: {},
    methods: {
        async sendToken() {
            let fd = new FormData()
            fd.append('token', this.token)
            fetch(`${API_URL}/add-bot`, {
                method: 'POST',
                body: fd,
            }).then((response) => {
                console.log(response)
            })
        },
    },
}
</script>
